(function () {
  var STYLESHEET_ID = "quartz-parts-finder-styles";

  function ensureStyles() {
    if (document.getElementById(STYLESHEET_ID)) return;
    var style = document.createElement("style");
    style.id = STYLESHEET_ID;
    style.textContent =
      ":root{--qpf-font:inherit;--qpf-text:#111827;--qpf-muted:#4b5563;--qpf-border:#d9dee6;--qpf-panel:#f7f8fa;--qpf-blue:#0f4f8d;--qpf-blue-soft:#f3f6fb;--qpf-red:#e23f34;--qpf-input-border:#b6bfcb;--qpf-radius:8px}" +
      ".qpf-wrap{max-width:1480px;margin:18px auto;padding:0 40px;box-sizing:border-box;font-family:var(--qpf-font);color:var(--qpf-text)}" +
      ".qpf-toolbar{display:grid;gap:8px;grid-template-columns:minmax(220px,1.2fr) repeat(3,minmax(140px,1fr)) auto auto;align-items:center;border:1px solid var(--qpf-border);background:var(--qpf-panel);border-radius:var(--qpf-radius);padding:12px}" +
      ".qpf-title{font-size:24px;line-height:1;font-weight:700;letter-spacing:1px;color:var(--qpf-text);padding:0 6px;white-space:nowrap}" +
      ".qpf-grid{display:grid;gap:10px;grid-template-columns:repeat(3,minmax(0,1fr));max-width:980px}" +
      ".qpf-field,.qpf-btn{width:100%;padding:9px 10px;border-radius:6px;font-family:var(--qpf-font);font-size:14px;line-height:1.2;min-height:40px}" +
      ".qpf-field{border:1px solid var(--qpf-input-border);background:#fff;font-weight:500;color:var(--qpf-text)}" +
      ".qpf-btn{border:1px solid transparent;background:var(--qpf-blue);color:#fff;font-weight:700;cursor:pointer;letter-spacing:0.2px}" +
      ".qpf-btn.search,.qpf-btn.clear{text-transform:uppercase;padding-left:14px;padding-right:14px;width:auto;white-space:nowrap}" +
      ".qpf-btn.clear{background:#fff;color:var(--qpf-text);border-color:var(--qpf-input-border)}" +
      ".qpf-btn:disabled{opacity:0.65;cursor:wait}" +
      ".qpf-msg{font-size:14px;color:var(--qpf-muted);margin:10px 0}" +
      ".qpf-loading{display:inline-flex;align-items:center;gap:8px;font-size:14px;color:var(--qpf-muted)}" +
      ".qpf-spinner{width:14px;height:14px;border:2px solid #d1d5db;border-top-color:var(--qpf-blue);border-radius:50%;animation:qpf-spin 0.8s linear infinite}" +
      ".qpf-error{font-size:14px;color:#b42318;background:#fff3f2;border:1px solid #fecdc8;border-radius:8px;padding:10px;margin:10px 0}" +
      ".qpf-results-shell{display:grid;gap:22px;align-items:flex-start}" +
      ".qpf-sidebar-card{background:var(--qpf-panel);border:1px solid var(--qpf-border);border-radius:var(--qpf-radius);padding:12px}" +
      ".qpf-side-actions{display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:10px}" +
      ".qpf-side-btn{border:1px solid var(--qpf-input-border);background:#fff;color:var(--qpf-text);border-radius:6px;min-height:40px;padding:8px 10px;font-size:14px;font-family:var(--qpf-font);font-weight:600;cursor:pointer}" +
      ".qpf-side-input{width:100%;border:1px solid var(--qpf-input-border);border-radius:6px;padding:9px 10px;font-size:14px;font-family:var(--qpf-font);color:var(--qpf-text)}" +
      ".qpf-main-title{margin:0 0 14px 0;font-size:44px;line-height:1;font-weight:700;letter-spacing:1px;color:var(--qpf-text)}" +
      ".qpf-results-head{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-bottom:10px}" +
      ".qpf-head-actions{display:inline-flex;align-items:center;gap:8px;flex-wrap:wrap}" +
      ".qpf-enquiry{border:0;background:var(--qpf-blue);color:#fff;border-radius:6px;padding:10px 14px;font-size:14px;font-family:var(--qpf-font);font-weight:700;cursor:pointer;white-space:nowrap}" +
      ".qpf-results-tools{margin:0 0 12px 0;max-width:360px}" +
      ".qpf-group{border:1px solid var(--qpf-border);border-radius:6px;background:#fff;margin-bottom:10px;overflow:hidden}" +
      ".qpf-group[open] summary{background:var(--qpf-blue);color:#fff}" +
      ".qpf-group summary{cursor:pointer;list-style:none;background:var(--qpf-panel);padding:9px 12px;font-size:16px;font-weight:700;display:flex;justify-content:space-between;align-items:center}" +
      ".qpf-group summary::-webkit-details-marker{display:none}" +
      ".qpf-group-body{padding:0;   }" +
      ".qpf-group-count{font-size:12px;font-weight:600;color:#000;}" +
      ".qpf-child-head{padding:8px 12px;border-top:1px solid #e7ebf1;border-bottom:1px solid #e7ebf1;background:var(--qpf-blue-soft);font-size:14px;font-weight:700;color:var(--qpf-text)}" +
      ".qpf-col-head{display:grid;grid-template-columns:96px minmax(220px,1fr) 120px 110px 140px;gap:12px;padding:8px 12px;font-size:14px;font-weight:700;color:var(--qpf-text);border-bottom:1px solid #e5e7eb;background:var(--qpf-panel)}" +
      ".qpf-item-row{display:grid;grid-template-columns:96px minmax(220px,1fr) 120px 110px 140px;gap:12px;padding:10px 12px;border-bottom:1px solid #edf0f5;align-items:center;font-size:14px;color:var(--qpf-text)}" +
      ".qpf-item-row:last-child{border-bottom:0}" +
      ".qpf-name-wrap{display:grid;grid-template-columns:56px 1fr;gap:10px;align-items:center}" +
      ".qpf-thumb-link{display:inline-block;line-height:0}" +
      ".qpf-thumb{width:56px;height:56px;object-fit:contain;border:1px solid #e5e7eb;border-radius:6px;background:#fff}" +
      ".qpf-title-cell{font-weight:600;color:var(--qpf-text)}" +
      ".qpf-sku-cell{font-weight:600;color:var(--qpf-blue)}" +
      ".qpf-value-cell{font-weight:600}" +
      ".qpf-price-wrap{display:inline-flex;align-items:center;gap:8px;flex-wrap:wrap}" +
      ".qpf-price-old{text-decoration:line-through;color:var(--qpf-muted);font-weight:500}" +
      ".qpf-price-promo{color:#b42318;font-weight:700}" +
      ".qpf-action-stack{display:flex;align-items:center;gap:8px;flex-wrap:wrap}" +
      ".qpf-view-btn{display:inline-flex;align-items:center;justify-content:center;min-height:34px;padding:0 12px;border-radius:6px;background:var(--qpf-blue);color:#fff;text-decoration:none;font-weight:700;font-size:13px;white-space:nowrap}" +
      ".qpf-add-btn{border:0;background:var(--qpf-red);cursor:pointer}" +
      ".qpf-view-btn:hover{filter:brightness(0.95)}" +
      ".qpf-sku{display:inline-block;background:#e8f1ff;color:#2158ad;font-size:12px;font-weight:600;padding:3px 7px;border-radius:6px;margin-bottom:4px}" +
      ".qpf-name{font-size:18px;line-height:1.25;color:#0b3d91;font-weight:500}" +
      ".qpf-subs{margin-top:5px;font-size:12px;color:#4b5563}" +
      ".qpf-sub-chip{display:inline-block;background:#eef2f7;border:1px solid #d9dfe8;border-radius:999px;padding:2px 8px;margin-right:4px;margin-top:4px}" +
      ".qpf-card{border:1px solid #ddd;border-radius:12px;padding:14px;margin:14px 0;background:#fff}" +
      ".qpf-row{display:grid;gap:12px;grid-template-columns:repeat(2,minmax(0,1fr))}" +
      ".qpf-subcard{border:1px solid #e4e4e7;border-radius:10px;padding:12px;margin-top:8px}" +
      ".qpf-muted{font-size:13px;color:#555}" +
      "@keyframes qpf-spin{to{transform:rotate(360deg)}}" +
      "@media(max-width:1700px){.qpf-title,.qpf-main-title{font-size:36px}.qpf-field,.qpf-btn{font-size:14px;min-height:40px}}" +
      "@media(max-width:1260px){.qpf-toolbar{grid-template-columns:1fr 1fr}.qpf-title{grid-column:1/-1}.qpf-btn.search,.qpf-btn.clear{width:100%}}" +
      "@media(max-width:980px){.qpf-results-shell{grid-template-columns:1fr}.qpf-col-head,.qpf-item-row{grid-template-columns:82px minmax(180px,1fr) 100px 90px 120px}.qpf-group summary{font-size:15px}}" +
      "@media(max-width:780px){.qpf-wrap{padding:0 20px}.qpf-grid,.qpf-row,.qpf-toolbar{grid-template-columns:1fr}.qpf-title,.qpf-main-title{font-size:30px}.qpf-field,.qpf-btn{font-size:15px}.qpf-col-head,.qpf-item-row{grid-template-columns:1fr}.qpf-col-head{display:none}.qpf-results-head{align-items:flex-start;flex-direction:column}.qpf-results-tools{max-width:100%}.qpf-head-actions{width:100%}}";
    document.head.appendChild(style);
  }

  function qs(target, selector) {
    return target.querySelector(selector);
  }

  function el(tag, attrs, text) {
    var node = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (key) {
        node.setAttribute(key, attrs[key]);
      });
    }
    if (text) node.textContent = text;
    return node;
  }

  function unique(items) {
    return Array.from(new Set((items || []).filter(Boolean)));
  }

  async function fetchJson(url) {
    var response = await fetch(url, { credentials: "omit" });
    var json = await response.json();
    if (!response.ok) {
      throw new Error(json && json.error ? json.error : "Request failed.");
    }
    return json;
  }

  function buildSearchParams(params) {
    var search = new URLSearchParams();
    Object.keys(params).forEach(function (key) {
      var value = params[key];
      if (value) search.set(key, value);
    });
    return search.toString();
  }

  function getUrlVehicleParams() {
    var params = new URLSearchParams(window.location.search);
    return {
      year: params.get("year") || "",
      makeId: params.get("makeId") || params.get("make") || "",
      modelId: params.get("modelId") || params.get("model") || "",
    };
  }

  function getCurrentShopDomain() {
    if (window.Shopify && window.Shopify.shop) {
      return String(window.Shopify.shop).toLowerCase();
    }
    return "";
  }

  function getGlobalConfig() {
    var config = window.QuartzPartsFinderConfig || {};
    return {
      apiBaseUrl: String(config.apiBaseUrl || ""),
      resultsPagePath: String(config.resultsPagePath || "/pages/parts-finder"),
    };
  }

  function normalizePath(pathname) {
    var value = String(pathname || "").trim();
    if (!value) return "/";
    var normalized = value.replace(/\/+$/, "");
    return normalized || "/";
  }

  function isOnResultsPage(resultsPagePath) {
    var currentPath = normalizePath(window.location.pathname);
    var configuredPath = normalizePath(resultsPagePath);
    return currentPath === configuredPath;
  }

  function createAutoResultsRoot(config) {
    var mountTarget =
      document.querySelector("main") ||
      document.querySelector("#MainContent") ||
      document.body;
    var wrapper = el("div", {
      class: "quartz-parts-finder-results",
      "data-mode": "results",
      "data-api-base": config.apiBaseUrl,
      style: "margin:24px auto;padding:0 16px;box-sizing:border-box;",
    });

    mountTarget.appendChild(wrapper);
    return wrapper;
  }

  async function renderSearchWidget(root) {
    ensureStyles();
    var config = getGlobalConfig();
    var apiBase = root.dataset.apiBase || config.apiBaseUrl || "";
    var resultsPath =
      root.dataset.resultsPath ||
      config.resultsPagePath ||
      "/pages/parts-finder";

    root.innerHTML =
      '<div class="qpf-wrap">' +
      '<div class="qpf-toolbar">' +
      '<div class="qpf-title">PARTS FINDER</div>' +
      '<select class="qpf-field" data-role="year"><option value="">Year</option></select>' +
      '<select class="qpf-field" data-role="make"><option value="">Make</option></select>' +
      '<select class="qpf-field" data-role="model"><option value="">Model</option></select>' +
      '<button class="qpf-btn search" data-role="search">SEARCH</button>' +
      '<button class="qpf-btn clear" data-role="clear">CLEAR</button>' +
      '</div><div data-role="status" class="qpf-msg" style="display:none"></div>' +
      "</div>";

    var yearSelect = qs(root, '[data-role="year"]');
    var makeSelect = qs(root, '[data-role="make"]');
    var modelSelect = qs(root, '[data-role="model"]');
    var button = qs(root, '[data-role="search"]');
    var clearButton = qs(root, '[data-role="clear"]');
    var status = qs(root, '[data-role="status"]');

    function setLoading(isLoading, message) {
      status.style.display = isLoading ? "block" : "none";
      status.innerHTML = isLoading
        ? '<span class="qpf-loading"><span class="qpf-spinner"></span>' +
          String(message || "Loading...") +
          "</span>"
        : "";
      yearSelect.disabled = isLoading;
      makeSelect.disabled = isLoading;
      modelSelect.disabled = isLoading;
      button.disabled = isLoading;
      clearButton.disabled = isLoading;
    }

    function hasOption(selectNode, value) {
      if (!value) return false;
      return Array.from(selectNode.options).some(function (option) {
        return option.value === value;
      });
    }

    function resetOptions(selectNode, placeholder) {
      selectNode.innerHTML = "";
      selectNode.appendChild(el("option", { value: "" }, placeholder));
    }

    async function loadOptions(year, makeId, options) {
      var settings = options || {};
      var keepYear = settings.keepYear !== false;
      var keepMake = settings.keepMake !== false;
      var keepModel = settings.keepModel !== false;

      var previousYear = yearSelect.value;
      var previousMake = makeSelect.value;
      var previousModel = modelSelect.value;

      setLoading(true, "Loading vehicles...");
      var query = buildSearchParams({
        year: year,
        makeId: makeId,
        shop: getCurrentShopDomain(),
      });
      var data;
      try {
        data = await fetchJson(apiBase + "/api/parts-finder/options?" + query);
      } finally {
        setLoading(false, "");
      }

      if (!year) {
        resetOptions(yearSelect, "Year");
        (data.years || []).forEach(function (entry) {
          yearSelect.appendChild(el("option", { value: entry }, entry));
        });
        if (keepYear && hasOption(yearSelect, previousYear)) {
          yearSelect.value = previousYear;
        }
      }

      resetOptions(makeSelect, "Make");
      (data.makes || []).forEach(function (entry) {
        makeSelect.appendChild(el("option", { value: entry.id }, entry.name));
      });
      if (keepMake && hasOption(makeSelect, previousMake)) {
        makeSelect.value = previousMake;
      }

      resetOptions(modelSelect, "Model");
      (data.models || []).forEach(function (entry) {
        modelSelect.appendChild(el("option", { value: entry.id }, entry.name));
      });
      if (keepModel && hasOption(modelSelect, previousModel)) {
        modelSelect.value = previousModel;
      }
    }

    async function applySelectionFromUrl() {
      var initial = getUrlVehicleParams();
      if (!initial.year && !initial.modelId && !initial.makeId) return;

      if (initial.year && hasOption(yearSelect, initial.year)) {
        yearSelect.value = initial.year;
      }

      if (initial.year) {
        await loadOptions(initial.year, "", {
          keepYear: true,
          keepMake: false,
          keepModel: false,
        });
      }

      if (initial.makeId && hasOption(makeSelect, initial.makeId)) {
        makeSelect.value = initial.makeId;
        await loadOptions(initial.year || yearSelect.value, initial.makeId, {
          keepYear: true,
          keepMake: true,
          keepModel: false,
        });
      }

      if (initial.modelId && hasOption(modelSelect, initial.modelId)) {
        modelSelect.value = initial.modelId;
      }
    }

    yearSelect.addEventListener("change", async function () {
      await loadOptions(yearSelect.value, "", {
        keepYear: true,
        keepMake: false,
        keepModel: false,
      });
    });

    makeSelect.addEventListener("change", async function () {
      await loadOptions(yearSelect.value, makeSelect.value, {
        keepYear: true,
        keepMake: true,
        keepModel: false,
      });
    });

    button.addEventListener("click", function () {
      var query = buildSearchParams({
        year: yearSelect.value,
        makeId: makeSelect.value,
        modelId: modelSelect.value,
      });
      if (!query) return;
      window.location.assign(resultsPath + "?" + query);
    });

    clearButton.addEventListener("click", function () {
      yearSelect.value = "";
      makeSelect.value = "";
      modelSelect.value = "";
      loadOptions("", "", {
        keepYear: false,
        keepMake: false,
        keepModel: false,
      }).catch(function () {
        status.style.display = "block";
        status.textContent = "Unable to reset finder options.";
      });
    });

    await loadOptions("", "", {
      keepYear: false,
      keepMake: false,
      keepModel: false,
    });
    await applySelectionFromUrl();
  }

  function renderProductCard(item) {
    var wrapper = el("div", { class: "qpf-subcard" });
    var title = el(
      "div",
      null,
      item && item.product ? item.product.title : "No Shopify match",
    );
    title.style.fontWeight = "600";
    wrapper.appendChild(title);

    if (item && item.price) {
      wrapper.appendChild(
        el("div", { class: "qpf-muted" }, "Price: " + item.price),
      );
    }

    if (
      item &&
      item.inventoryQuantity !== undefined &&
      item.inventoryQuantity !== null
    ) {
      wrapper.appendChild(
        el(
          "div",
          { class: "qpf-muted" },
          "Inventory: " + item.inventoryQuantity,
        ),
      );
    }

    return wrapper;
  }

  function getFitmentParentHeading(item) {
    var raw =
      (item && (item.parentHeading || item.heading_parent)) || "General";
    return String(raw || "General").trim() || "General";
  }

  function getFitmentHeading(item) {
    var raw = (item && (item.heading || item.subheading)) || "Parts";
    return String(raw || "Parts").trim() || "Parts";
  }

  function groupByHeading(items) {
    var groups = new Map();
    (items || []).forEach(function (item) {
      var parentHeading = getFitmentParentHeading(item);
      var heading = getFitmentHeading(item);

      if (!groups.has(parentHeading)) {
        groups.set(parentHeading, new Map());
      }
      var childGroups = groups.get(parentHeading);
      if (!childGroups.has(heading)) {
        childGroups.set(heading, []);
      }
      childGroups.get(heading).push(item);
    });

    return Array.from(groups.entries())
      .sort(function (a, b) {
        return String(a[0]).localeCompare(String(b[0]), undefined, {
          sensitivity: "base",
        });
      })
      .map(function (entry) {
        return {
          parentHeading: entry[0],
          childGroups: Array.from(entry[1].entries())
            .sort(function (a, b) {
              return String(a[0]).localeCompare(String(b[0]), undefined, {
                sensitivity: "base",
              });
            })
            .map(function (childEntry) {
              return {
                heading: childEntry[0],
                items: childEntry[1],
              };
            }),
        };
      });
  }

  function renderResultsShell(root, data, meta) {
    var wrap = el("div", { class: "qpf-wrap" });
    var shell = el("div", { class: "qpf-results-shell" });
    var apiBase = String(meta.apiBase || "");

    var filter = el("input", {
      class: "qpf-side-input",
      type: "text",
      placeholder: "Keyword filter",
      "data-role": "keyword-filter",
    });

    var main = el("section", null);
    var head = el("div", { class: "qpf-results-head" });
    var title = el("h2", { class: "qpf-main-title" }, meta.title);
    var headActions = el("div", { class: "qpf-head-actions" });
    var enquiry = el(
      "a",
      { class: "qpf-enquiry", href: "/pages/contact" },
      "Product / fitment enquiry",
    );
    var changeModel = el(
      "a",
      { class: "qpf-enquiry", href: "/pages/parts-finder" },
      "Change Model",
    );
    head.appendChild(title);
    headActions.appendChild(enquiry);
    headActions.appendChild(changeModel);
    head.appendChild(headActions);
    var tools = el("div", { class: "qpf-results-tools" });
    tools.appendChild(filter);

    var groupsWrap = el("div", { "data-role": "groups-wrap" });

    var grouped = groupByHeading(data.items || []);

    function resolveProductNode(item) {
      var source = item || {};
      var directUrl = source.productUrl || source.product_url || "";
      var quantity =
        source.inventoryQuantity === undefined ||
        source.inventoryQuantity === null
          ? "-"
          : String(source.inventoryQuantity);

      return {
        sku: String(source.sku || "").trim(),
        title: String(
          source.title || source.name || source.sku || "Part",
        ).trim(),
        imageUrl:
          source.imageUrl ||
          "https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_medium.png",
        qty: quantity,
        defaultPriceRaw:
          source.default_price || source.defaultPrice || source.rrp || "",
        promotionPriceRaw:
          source.promotion_price || source.promotionPrice || "",
        productUrl: String(directUrl || "").trim(),
      };
    }

    function normalizeProductUrl(url, sku) {
      var raw = String(url || "").trim();
      if (raw) {
        if (/^https?:\/\//i.test(raw) || raw.charAt(0) === "/") return raw;
        return "/products/" + encodeURIComponent(raw);
      }
      return sku ? "/products/" + encodeURIComponent(sku) : "";
    }

    function toCartVariantId(variantId) {
      var raw = String(variantId || "").trim();
      if (!raw) return "";
      if (/^\d+$/.test(raw)) return raw;
      var match = raw.match(/\/(\d+)$/);
      return match ? match[1] : "";
    }

    async function resolveVariantIdBySku(sku) {
      var query = buildSearchParams({
        sku: sku,
        shop: getCurrentShopDomain(),
      });
      var payload = await fetchJson(
        apiBase + "/api/parts-finder/variant?" + query,
      );
      if (!payload) return "";
      return toCartVariantId(payload.variantId || payload.variantGid || "");
    }

    async function addVariantToCart(variantId) {
      var response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
        credentials: "same-origin",
      });

      if (!response.ok) {
        var errorText = "Failed to add to cart.";
        try {
          var payload = await response.json();
          errorText =
            payload && payload.description ? payload.description : errorText;
        } catch {
          // no-op
        }
        throw new Error(errorText);
      }
    }

    async function handleAddToCart(sku, button) {
      if (!sku || !button) return;
      var originalText = button.textContent;
      button.disabled = true;
      button.textContent = "Adding...";

      try {
        var variantId = await resolveVariantIdBySku(sku);
        if (!variantId) {
          throw new Error("Variant not found for this SKU.");
        }

        await addVariantToCart(variantId);
        button.textContent = "Added";
      } catch (error) {
        button.textContent = "Failed";
        console.error(error);
      }

      setTimeout(function () {
        button.disabled = false;
        button.textContent = originalText;
      }, 1200);
    }

    function formatMoney(value) {
      var raw = String(value || "").trim();
      if (!raw) return "-";
      if (raw.indexOf("$") === 0) return raw;
      var parsed = Number(raw);
      if (!Number.isFinite(parsed)) return raw;
      return "$" + parsed.toFixed(2);
    }

    function hasPromoPrice(value) {
      var raw = String(value || "").trim();
      if (!raw) return false;
      if (raw === "$0.00") return false;
      var numeric = Number(raw.replace(/[^0-9.-]/g, ""));
      if (!Number.isFinite(numeric)) return true;
      return numeric !== 0;
    }

    grouped.forEach(function (groupEntry, idx) {
      var parentHeading = groupEntry.parentHeading;
      var childGroups = groupEntry.childGroups;
      var parentItemCount = childGroups.reduce(function (acc, child) {
        return acc + child.items.length;
      }, 0);

      var details = el("details", {
        class: "qpf-group",
        "data-group": parentHeading.toLowerCase(),
      });
      //   if (idx === 0) details.open = true;
      var summary = el("summary", null, parentHeading);
      summary.appendChild(
        el("span", { class: "qpf-group-count" }, String(parentItemCount)),
      );
      details.appendChild(summary);

      var body = el("div", { class: "qpf-group-body" });
      childGroups.forEach(function (childGroup) {
        var childHeadingBar = el(
          "div",
          { class: "qpf-child-head" },
          childGroup.heading,
        );
        body.appendChild(childHeadingBar);

        var colHead = el("div", { class: "qpf-col-head" });
        colHead.appendChild(el("div", null, "Image"));
        colHead.appendChild(el("div", null, "Title"));
        colHead.appendChild(el("div", null, "Price"));
        colHead.appendChild(el("div", null, "Qty in stock"));
        colHead.appendChild(el("div", null, ""));
        body.appendChild(colHead);

        childGroup.items.forEach(function (item) {
          var row = el("div", {
            class: "qpf-item-row",
            "data-search": [
              item.name,
              item.sku,
              parentHeading,
              childGroup.heading,
            ]
              .join(" ")
              .toLowerCase(),
          });

          var productInfo = resolveProductNode(item);
          var imageCell = el("div", null);
          var productPath = normalizeProductUrl(
            productInfo.productUrl,
            productInfo.sku,
          );
          var thumb = el("img", {
            class: "qpf-thumb",
            src: productInfo.imageUrl,
            alt: productInfo.sku || productInfo.title || "Part",
            loading: "lazy",
          });

          if (productPath) {
            var thumbLink = el("a", {
              class: "qpf-thumb-link",
              href: productPath,
            });
            thumbLink.appendChild(thumb);
            imageCell.appendChild(thumbLink);
          } else {
            imageCell.appendChild(thumb);
          }

          var defaultPrice = formatMoney(productInfo.defaultPriceRaw);
          var promoPrice = formatMoney(productInfo.promotionPriceRaw);
          var showPromo = hasPromoPrice(productInfo.promotionPriceRaw);

          row.appendChild(imageCell);
          row.appendChild(
            el("div", { class: "qpf-title-cell" }, productInfo.title || "-"),
          );
          var priceCell = el("div", { class: "qpf-value-cell" });
          if (showPromo) {
            var priceWrap = el("div", { class: "qpf-price-wrap" });
            priceWrap.appendChild(
              el("span", { class: "qpf-price-old" }, defaultPrice),
            );
            priceWrap.appendChild(
              el("span", { class: "qpf-price-promo" }, promoPrice),
            );
            priceCell.appendChild(priceWrap);
          } else {
            priceCell.appendChild(document.createTextNode(defaultPrice || "-"));
          }
          row.appendChild(priceCell);
          row.appendChild(
            el("div", { class: "qpf-value-cell" }, productInfo.qty),
          );
          var actionCell = el("div", { class: "qpf-action-stack" });
          if (productPath) {
            actionCell.appendChild(
              el(
                "a",
                {
                  class: "qpf-view-btn",
                  href: productPath,
                },
                "View product",
              ),
            );
          } else {
            actionCell.appendChild(el("span", { class: "qpf-muted" }, "-"));
          }

          //   if (productInfo.sku) {
          //     var addButton = el(
          //       "button",
          //       {
          //         class: "qpf-view-btn qpf-add-btn",
          //         type: "button",
          //       },
          //       "Add to cart",
          //     );
          //     addButton.addEventListener("click", function () {
          //       handleAddToCart(productInfo.sku, addButton);
          //     });
          //     actionCell.appendChild(addButton);
          //   }
          row.appendChild(actionCell);

          body.appendChild(row);
        });
      });

      details.appendChild(body);
      groupsWrap.appendChild(details);
    });

    filter.addEventListener("input", function () {
      var query = String(filter.value || "")
        .trim()
        .toLowerCase();
      groupsWrap.querySelectorAll("details").forEach(function (group) {
        var rows = group.querySelectorAll(".qpf-item-row");
        var visibleCount = 0;
        rows.forEach(function (row) {
          var searchable = row.getAttribute("data-search") || "";
          var matched = !query || searchable.indexOf(query) > -1;
          row.style.display = matched ? "grid" : "none";
          if (matched) visibleCount += 1;
        });
        group.style.display = visibleCount ? "block" : "none";
      });
    });

    main.appendChild(head);
    main.appendChild(tools);
    main.appendChild(groupsWrap);
    shell.appendChild(main);
    wrap.appendChild(shell);

    root.innerHTML = "";
    root.appendChild(wrap);
  }

  async function renderResults(root) {
    ensureStyles();
    var config = getGlobalConfig();
    var apiBase = root.dataset.apiBase || config.apiBaseUrl || "";
    var params = new URLSearchParams(window.location.search);
    var year = params.get("year") || "";
    var makeId = params.get("makeId") || params.get("make") || "";
    var modelId = params.get("modelId") || params.get("model") || "";

    if (!apiBase) {
      root.innerHTML =
        '<div class="qpf-wrap"><p class="qpf-error">Parts finder API base URL is missing. Set App API base URL in the block/embed settings.</p></div>';
      return;
    }

    if (!year || !modelId) {
      await renderSearchWidget(root);
      return;
    }

    root.innerHTML =
      '<div class="qpf-wrap"><p class="qpf-loading"><span class="qpf-spinner"></span>Loading parts...</p></div>';
    var query = buildSearchParams({
      year: year,
      makeId: makeId,
      modelId: modelId,
      shop: getCurrentShopDomain(),
    });
    var data;
    try {
      data = await fetchJson(apiBase + "/api/parts-finder/search?" + query);
    } catch (error) {
      root.innerHTML =
        '<div class="qpf-wrap"><p class="qpf-error">Unable to load parts finder results. ' +
        String(error && error.message ? error.message : "Unknown error") +
        "</p></div>";
      throw error;
    }

    if (!data.items || !data.items.length) {
      root.innerHTML =
        '<p class="qpf-msg">No fitments found for this vehicle. If this seems wrong, verify year/make/model IDs and substitute mappings.</p>';
      return;
    }

    var readableTitle = String(year + " Parts Finder Results").trim();
    try {
      var optionsQuery = buildSearchParams({
        year: year,
        makeId: makeId,
        shop: getCurrentShopDomain(),
      });
      var optionsData = await fetchJson(
        apiBase + "/api/parts-finder/options?" + optionsQuery,
      );
      var makeName = "";
      var modelName = "";
      (optionsData.makes || []).forEach(function (entry) {
        if (String(entry.id) === String(makeId)) makeName = entry.name || "";
      });
      (optionsData.models || []).forEach(function (entry) {
        if (String(entry.id) === String(modelId)) modelName = entry.name || "";
      });

      if (!makeName && modelId) {
        var allModelsData = await fetchJson(
          apiBase +
            "/api/parts-finder/options?" +
            buildSearchParams({ year: year, shop: getCurrentShopDomain() }),
        );
        var matchedModel = (allModelsData.models || []).find(function (entry) {
          return String(entry.id) === String(modelId);
        });
        if (matchedModel) {
          modelName = matchedModel.name || modelName;
          var inferredMakeId = matchedModel.makeId;
          var matchedMake = (allModelsData.makes || []).find(function (entry) {
            return String(entry.id) === String(inferredMakeId);
          });
          if (matchedMake) makeName = matchedMake.name || makeName;
        }
      }

      readableTitle = [year, makeName, modelName].filter(Boolean).join(" ");
      if (!readableTitle) {
        readableTitle = String(year + " Parts Finder Results").trim();
      }
    } catch {
      readableTitle = String(year + " Parts Finder Results").trim();
    }

    renderResultsShell(root, data, {
      title: readableTitle,
      apiBase: apiBase,
    });
  }

  function boot() {
    ensureStyles();
    var roots = document.querySelectorAll(
      ".quartz-parts-finder-widget, .quartz-parts-finder-results",
    );

    if (!roots.length) {
      var config = getGlobalConfig();
      if (isOnResultsPage(config.resultsPagePath)) {
        roots = [createAutoResultsRoot(config)];
      }
    }

    roots.forEach(function (root) {
      var mode = root.dataset.mode || "search";
      if (mode === "results") {
        renderResults(root).catch(function (error) {
          root.innerHTML = "<p>Unable to load parts finder results.</p>";
          console.error(error);
        });
        return;
      }

      renderSearchWidget(root).catch(function (error) {
        root.innerHTML = "<p>Unable to load parts finder search.</p>";
        console.error(error);
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
